import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractPartialPayment } from '../../AbstractPartialPayment';
import { PayableTableObject, PayableType } from '../../../invoices/models/payable-table-object';
import { InvoicePdfService } from '../../../invoices/service/invoice-pdf.service';
import { AssetUriService, ConfigService } from '@aiwyn/config';
import { ROUTE_TOKEN_ENGAGEMENTS_BASE, ROUTE_TOKEN_MAIN_BASE } from '../../../../../routing-constants';
import { Store } from '@ngxs/store';

const DUE_UPON_RECEIPT = 'Due upon receipt';

@Component({
  selector: 'app-invoice-card',
  templateUrl: './invoice-card.component.html',
  styleUrls: ['./invoice-card.component.scss'],
  standalone: false,
})
export class InvoiceCardComponent extends AbstractPartialPayment implements OnInit, OnDestroy {

  PayableType = PayableType;
  ROUTE_TOKEN_MAIN_BASE = ROUTE_TOKEN_MAIN_BASE;
  ROUTE_TOKEN_ENGAGEMENTS_BASE = ROUTE_TOKEN_ENGAGEMENTS_BASE;
  DUE_UPON_RECEIPT = DUE_UPON_RECEIPT;

  @ViewChild('payPartialInput')
  payPartialInput: ElementRef;

  @Input()
  invoiceTableDataObject: PayableTableObject;

  @Output()
  removed: EventEmitter<number> = new EventEmitter();

  constructor(
    public configService: ConfigService,
    public assetUriService: AssetUriService,
    public invoicePdfService: InvoicePdfService,
    protected store: Store,
  ) {
    super(configService, store);
  }

  ngOnInit(): void {
    this.amountToPay = this.getMaximumAmount(this.invoiceTableDataObject);
  }

  activatePayPartial(): void {
    this.payPartialActive = true;
    this.validate(this.invoiceTableDataObject);

    // TODO Get this working without a setTimeout.
    setTimeout(() => this.payPartialInput.nativeElement.focus(), 100);
  }

  onRemovePayable(payableId: number): void {
    this.removed.emit(payableId);
  }

  ngOnDestroy() {
    super.onDestroy();
  }
}
